module.exports = __webpack_public_path__ + "img/BAU Seniors_Infographics_37.c37fa371.png";